module.exports = __webpack_public_path__ + "static/img/playing.eebf9f50.gif";